import type { DeliveryZoneCode } from '@noths/polaris-client-localisation';
import type { PayloadAction, SerializedError } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { DeliveryBlockOnCountryChangeArgs } from 'src/components/organisms/DeliveryBlock/types';
import type { DeliverySettingsAPIDeliveryZone } from 'src/services/delivery-settings/types/DeliverySettingsAPIDeliveryZone';
import { logger } from 'src/utils/serverLogger';
import { requestDeliveryZoneOptions } from './thunks';

export interface DeliveryState {
  error: SerializedError | null;
  options: DeliverySettingsAPIDeliveryZone[];
  previouslySelectedZone: DeliveryZoneCode | null;
  selectedCountry: string;
  selectedZone: DeliveryZoneCode;
}

export const initialState: Readonly<DeliveryState> = {
  error: null,
  options: [],
  previouslySelectedZone: null,
  selectedZone: 'MAINLAND_UK',
  selectedCountry: 'GB',
};

export const { actions, reducer } = createSlice({
  name: 'delivery',
  initialState,
  reducers: {
    setSelectedZone: (state, { payload }: PayloadAction<DeliveryZoneCode | undefined>) => {
      if (payload) {
        state.previouslySelectedZone = state.selectedZone;
        state.selectedZone = payload;
      }
    },
    setSelectedCountry: (
      state,
      { payload }: PayloadAction<DeliveryBlockOnCountryChangeArgs | string | undefined>,
    ) => {
      if (payload) {
        state.selectedCountry = typeof payload === 'object' ? payload.selectedCountry : payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestDeliveryZoneOptions.fulfilled, (state, { payload }) => {
        state.options = payload;
      })
      .addCase(requestDeliveryZoneOptions.rejected, (state, action) => {
        logger.warn('Error requesting delivery zone options', {
          error: action.payload || action.error,
        });

        state.error = action.error;
        state.options = [];
      });
  },
});
